import { useContext } from "react";
import { langContext } from "../../api/Lang";

const el = {
    title: "Το καλάθι μου",
    empty: "Το καλάθι σου είναι άδειο",
    emptyHint: "Πρόσθεσε γεύματα σε μία ή περισσότερες ημέρες και πλήρωσε για όλες μαζί.",
    changeLabel: "Αλλαγή",
    previousOrderLabel: "Προηγούμενη παραγγελία",
    total: "Σύνολο:",
    newTotal: "Νέο Σύνολο:",
    creditsLabel: "Χρήση Lunchbox credits",
    creditsRefundLabel: "Επιστροφή Lunchbox credits στο πορτοφόλι σου",
    willBecomePrefix: "Θα γίνουν",
    willRemainPrefix: "Θα απομείνουν",
    payButton: "Πληρωμή",
    completeButton: "Ολοκλήρωση παραγγελίας",
    paying: "Μεταφορά στην πληρωμή...",
    registering: "Καταχώρηση παραγγελιών...",
    vivaFailedTryAgain: "Κάτι πήγε στραβά με την πληρωμή σου. Δοκίμασε ξανά.",
    checkoutFailedTryAgain: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
    paymentSuccessTitle: "Η πληρωμή ολοκληρώθηκε!",
    paymentSuccessSubtitle: "Το ποσό πιστώθηκε στον λογαριασμό σου.",
    ordersRegisteredTitle: "Οι παραγγελίες σου καταχωρήθηκαν!",
    ordersRegisteredSubtitle: "Θα τις βρεις στις αντίστοιχες ημέρες.",
    registrationFailed: "Κάτι πήγε στραβά με την καταχώρηση των παραγγελιών σου. Το ποσό σου είναι διαθέσιμο ως Lunchbox credits — δοκίμασε ξανά.",
    partialRegisteredPrefix: "Καταχωρήθηκαν ",
    partialRegisteredMiddle: " από ",
    partialRegisteredSuffix: " ημέρες. Οι υπόλοιπες παραμένουν στο καλάθι σου και το ποσό τους είναι διαθέσιμο ως Lunchbox credits.",
    retryRegistration: "Δοκίμασε ξανά",
    close: "Κλείσιμο",
    viewBasket: "Δες το καλάθι",
    multiDayBasketHint: "Μπορείς να προσθέσεις παραγγελίες για πολλές ημέρες στο καλάθι σου και να τις ολοκληρώσεις όλες μαζί.",
    multiDayBasketHintShort: "Πρόσθεσε ημέρες στο καλάθι και ολοκλήρωσε όλες τις παραγγελίες μαζί.",
    basketAriaLabel: "Καλάθι",
    dayError: "Αυτή η ημέρα δεν καταχωρήθηκε",
    removeDay: "Αφαίρεση ημέρας από το καλάθι",
    removeLine: "Αφαίρεση",
    quantityLabel: "Ποσότητα",
    emptyBasket: "Άδειασμα καλαθιού",
    emptyBasketTitle: "Άδειασμα καλαθιού",
    emptyBasketMsg: "Θα αφαιρεθούν όλες οι ημέρες από το καλάθι σου. Συνέχεια;",
    expiredDaysTitle: "Προθεσμία παραγγελίας",
    removeBlockedDays: "Αφαίρεση ημερών με ληγμένη προθεσμία",
    payBlockedHint: "Αφαίρεσε τις ημέρες που η προθεσμία έχει περάσει για να συνεχίσεις.",
    staleAttentionTitle: "Χρειάζονται προσοχή",
    staleAttentionHint: "Αυτές οι ημέρες δεν μπορούν πλέον να καταχωρηθούν. Αφαίρεσέ τες από το καλάθι.",
    staleAttentionHintPartial: "Τα γεύματα μενού ημέρας δεν μπορούν πλέον να καταχωρηθούν. Αφαίρεσέ τα ή επέλεξε την ημέρα για επεξεργασία — τα υπόλοιπα γεύματά σου μπορούν ακόμα να πληρωθούν.",
    staleAttentionHintMixed: "Κάποιες ημέρες χρειάζονται μόνο αφαίρεση μενού ημέρας· άλλες πρέπει να βγουν ολόκληρες από το καλάθι.",
    staleRemoveSetMenuMeals: "Αφαίρεση γευμάτων μενού",
    staleEditDay: "Επεξεργασία ημέρας",
    staleGroupGeneralDeadline: "Προθεσμία παραγγελίας",
    staleGroupSetMenuDeadline: "Προθεσμία μενού ημέρας",
    staleGroupNoOrderableMeals: "Δεν υπάρχουν διαθέσιμα γεύματα",
    staleGeneralDeadlineAt: (at: string) => `Προθεσμία παραγγελίας: ${at}`,
    staleSetMenuDeadlineAt: (at: string) => `Προθεσμία μενού ημέρας: ${at}`,
    staleOrderForDay: (dayLabel: string) => `Παραγγελία για ${dayLabel}`,
    staleRemoveAll: "Αφαίρεση όλων",
    staleOnlyValidHint: "Δεν έχεις ημέρες έτοιμες προς πληρωμή. Δες παρακάτω τι πρέπει να αφαιρέσεις.",
    editDay: "Επεξεργασία",
    deadlineUrgencyGeneral: (days: string, hour: string) =>
        `Πρόλαβε την παραγγελία σου για ${days} πριν τις ${hour} — μετά δεν θα μπορείς να την ολοκληρώσεις από το καλάθι.`,
    deadlineUrgencySetMenu: (days: string, hour: string) =>
        `Πρόλαβε την παραγγελία για το μενού ημέρας για ${days} πριν τις ${hour} — μετά δεν θα μπορείς να την ολοκληρώσεις από το καλάθι.`,
    deadlineUrgencyOpenBasketCta: "Άνοιγμα καλαθιού",
    deadlineUrgencyOpenBasketAria: "Άνοιγμα καλαθιού — η προθεσμία πλησιάζει",
    deadlineUrgencyDismissAria: "Απόκρυψη προειδοποίησης για αυτή τη σύνδεση",
};

const en: typeof el = {
    title: "My basket",
    empty: "Your basket is empty",
    emptyHint: "Add meals to one or more days and pay for all of them at once.",
    changeLabel: "Change",
    previousOrderLabel: "Previous order",
    total: "Total:",
    newTotal: "New Total:",
    creditsLabel: "Use Lunchbox credits",
    creditsRefundLabel: "Lunchbox credits returned to your wallet",
    willBecomePrefix: "Will become",
    willRemainPrefix: "Will remain",
    payButton: "Payment",
    completeButton: "Complete order",
    paying: "Redirecting to payment...",
    registering: "Registering your orders...",
    vivaFailedTryAgain: "Something went wrong with your payment. Try again.",
    checkoutFailedTryAgain: "Something went wrong. Try again.",
    paymentSuccessTitle: "Payment completed!",
    paymentSuccessSubtitle: "The amount was credited to your account.",
    ordersRegisteredTitle: "Your orders were registered!",
    ordersRegisteredSubtitle: "You will find them on the corresponding days.",
    registrationFailed: "Something went wrong while registering your orders. Your money is available as Lunchbox credits — try again.",
    partialRegisteredPrefix: "Registered ",
    partialRegisteredMiddle: " of ",
    partialRegisteredSuffix: " days. The rest remain in your basket and their amount is available as Lunchbox credits.",
    retryRegistration: "Try again",
    close: "Close",
    viewBasket: "View basket",
    multiDayBasketHint: "You can add orders for multiple days to your basket and complete them all at once.",
    multiDayBasketHintShort: "Add days to your basket and complete every order together.",
    basketAriaLabel: "Basket",
    dayError: "This day was not registered",
    removeDay: "Remove day from basket",
    removeLine: "Remove",
    quantityLabel: "Quantity",
    emptyBasket: "Empty basket",
    emptyBasketTitle: "Empty basket",
    emptyBasketMsg: "All days will be removed from your basket. Continue?",
    expiredDaysTitle: "Order deadline",
    removeBlockedDays: "Remove days past the deadline",
    payBlockedHint: "Remove days past the order deadline to continue.",
    staleAttentionTitle: "Need attention",
    staleAttentionHint: "These days can no longer be checked out. Remove them from your basket.",
    staleAttentionHintPartial: "Set menu meals on these days can't be checked out. Remove them or edit the day — your other meals can still be paid for.",
    staleAttentionHintMixed: "Some days only need set menu meals removed; others must be removed from your basket entirely.",
    staleRemoveSetMenuMeals: "Remove set menu meals",
    staleEditDay: "Edit day",
    staleGroupGeneralDeadline: "Order deadline",
    staleGroupSetMenuDeadline: "Set menu deadline",
    staleGroupNoOrderableMeals: "No meals available",
    staleGeneralDeadlineAt: (at: string) => `Order deadline: ${at}`,
    staleSetMenuDeadlineAt: (at: string) => `Set menu deadline: ${at}`,
    staleOrderForDay: (dayLabel: string) => `Order for ${dayLabel}`,
    staleRemoveAll: "Remove all",
    staleOnlyValidHint: "You have no days ready to pay for. See below what you need to remove.",
    editDay: "Edit",
    deadlineUrgencyGeneral: (days: string, hour: string) =>
        `Complete your order for ${days} before ${hour} — after that you won't be able to finish it from the basket.`,
    deadlineUrgencySetMenu: (days: string, hour: string) =>
        `Complete your set menu order for ${days} before ${hour} — after that you won't be able to finish it from the basket.`,
    deadlineUrgencyOpenBasketCta: "Open basket",
    deadlineUrgencyOpenBasketAria: "Open basket — order deadline is approaching",
    deadlineUrgencyDismissAria: "Dismiss deadline warning for this session",
};

const basketLangs = { el, en };

export function useBasketStrings(): typeof el {
    const [lang] = useContext(langContext);
    return basketLangs[lang] ?? basketLangs.el;
}
